module.exports = __webpack_public_path__ + "img/glr_en.45359708.svg";